import { HttpClient } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { APP_CONFIG } from 'src/app/core/services/app-config.service';
import { AppConfig } from '../models/config-variable.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Car } from '../models/car.model';
import { Employee } from '../models/employee.model';
import { UserInfo } from '../models/user-info.model';

@Injectable({
  providedIn: 'root',
})
export class UserService {
	readonly ApiUrl:string = "/employees";
	readonly config: AppConfig=new AppConfig;

	constructor(private http: HttpClient, @Inject(APP_CONFIG) config: AppConfig) {
		this.config = config;
		this.ApiUrl = this.config.ApiUrl + this.ApiUrl;
	}

	public getCurrentUserProfile(): Observable<UserInfo> {
		return this.http.get<UserInfo>(`${this.ApiUrl}/current`);
	}

	public getUserCars(userId?: string): Observable<Car[]> {
		return this.http.get<Car[]>(this.carUrl(userId));
	}

	public addNewCar(newCar: string, userId?: string): Observable<Car> {
		return this.http.post<Car>(this.carUrl(userId), { label: newCar });
	}

	public deleteCar(carId: string, userId?: string): Observable<any> {
		return this.http.delete<any>(`${this.carUrl(userId)}/${carId}`);
	}

	public updateCar(
		carId: string,
		newCar: string,
		userId?: string,
	): Observable<any> {
		return this.http.put<any>(`${this.carUrl(userId)}/${carId}`, {
		label: newCar,
		});
	}

	public searchEmployees(usernames: string): Observable<Employee[]> {
		return this.http.get<Employee[]>(
		`${this.ApiUrl}/search?query=${usernames}`,
		);
  }

  public searchEmployeesByCarPlate(carLicensePlate: string): Observable<Employee[]> {
    return this.http.get<Employee[]>(
      `${this.ApiUrl}/current/searchCarsLicencePlate=${carLicensePlate}`,
    );
  }

	private carUrl(userId?: string): string {
		return userId
		? `${this.ApiUrl}/${userId}/cars`
		: `${this.ApiUrl}/current/cars`;
	}
}
